<template>
    <template v-if="showExtendedView">
        <template v-for="(dataLeak, index) in dataLeaks" :key="index">
            <div v-if="showDataLeak(dataLeak)" class="row panel info-row">
                <div class="columns small-4 leak-title leak-title-extended">
                    <div class="bold-text">{{ getDataLeakTitle(dataLeak.type) }}</div>
                </div>
                <div class="columns small-8">
                    <div class="row">
                        <div v-if="showMailIcon(dataLeak)" class="columns small-6">
                            <i class="fi fi-mail icon"/>
                        </div>
                        <div v-if="showPhoneIcon(dataLeak)" class="columns small-6">
                            <i class="fi fi-telephone icon"/>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="hint margin-top-10px">
            (<i class="fi fi-mail" /> - Ihre angegebene E-Mail Adresse ist von diesem Datenleck betroffen,
            <i class="fi fi-telephone" /> - Ihre angegebene Telefonnummer ist von diesem Datenleck betroffen)
        </div>
    </template>
    <template v-else>
        <template v-for="(dataLeak, index) in dataLeaks" :key="index">
            <div v-if="showDataLeak(dataLeak)" class="row">
                <div class="columns small-12 leak-title">
                    <div class="bold-text">{{ getDataLeakTitle(dataLeak.type) }}</div>
                </div>
            </div>
        </template>
    </template>
</template>

<script>
import DataLeakTypes from '../constants/DataLeakTypes';
import Modes from '../constants/Modes';

export default {
    name: 'DataLeaksInfo',
    props: {
        dataLeaks: Array,
        mode: Number
    },
    data: () => ({
        viewData: {

        },
        availableDataLeakTypes: DataLeakTypes.toArray()
    }),
    computed: {
        showExtendedView()
        {
            return this.mode === Modes.BOTH;
        }
    },
    methods: {
        showDataLeak(dataLeak)
        {
            if (dataLeak.mail_pwned && (this.mode === Modes.EMAIL || this.mode === Modes.BOTH))
                return true;

            if (dataLeak.phone_pwned && (this.mode === Modes.PHONE || this.mode === Modes.BOTH))
                return true;

            return false;
        },
        getDataLeakTitle(type)
        {
            return this.availableDataLeakTypes.find(leakType => leakType.value === type).title;
        },
        showPhoneIcon(dataLeak)
        {
            return dataLeak.phone_pwned === true;
        },
        showMailIcon(dataLeak)
        {
            return dataLeak.mail_pwned === true;
        }
    }
};
</script>

<style scoped>
.bold-text {
    font-weight: bold;
}

.leak-title div {
    font-size: 20px;
}

.leak-title-extended {
    height: 90px;
}
.leak-title-extended div {
    margin: 0;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
}

.margin-top-10px {
    margin-top: 10px;
}

.hint {
    font-size: 14px;
    font-style: italic;
}

.icon {
    color:#e10065;
    font-size: 60px;
    text-shadow: 0 1px 3px rgba(0,0,0,0.25);
}

.info-row {
    background-color: white;
    border-radius: 25px;
    margin-bottom: 5px;
}
</style>
